<template>
  <div class="wrap">
    <div class="container">
      <div class="banner-container">
        <div class="banner-info">
          <h3>
            网络安全威胁情报生态联盟
          </h3>
          <h3>
            Cybersecurity Ecology Alliance of Threat Intelligence
          </h3>
          <div class="info-contaner">
            <em>简称：CEATI</em>
            <em>官网：</em>
            <em>Website: https://www.ceati.org.cn</em>
            <em>TI portal: https://ti.ceati-portal.com</em>
          </div>
        </div>
        <div class="banner-img">
          <img src="../assets/images/banner.png" alt="">
        </div>
      </div>
      <div class="desc">
        <p>
          CEATI联盟全称：网络安全威胁情报生态联盟 ，英文全称：Cybersecurity  Ecology Alliance of Threat Intelligence ，简称：CEATI联盟是由奇安信威胁情报中心联手国内多个著名安全公司共同发起的共建威胁情报行业生态的联盟机构，旨在以威胁情报能力应用为核心，打造新生态圈模式，情报使能、共谋共策、开放合作、共赢未来。
        </p>
        <p>
          联盟成员公司，能力涵盖情报运营、APT跟踪、样本对抗、Web安全、数据安全、大数据分析、云安全、等保合规安全硬件等多方面关键技术。联盟依托奇安信、天际友盟大数据基础平台，为联盟内情报分析和处理提供有力支撑。
        </p>
        <p>
          联盟同时致力于降低行业威胁情报利用门槛、提升威胁情报使用效果以及体现最终客户侧的威胁情报价值，从而在整体上提高国内安全防护水位。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Introduce'
}
</script>

<style scoped lang="scss">
  .wrap {
    background-color: #FBFBFB;
    padding: 64px 0;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    padding: 16px;
    background: #FFFFFF;
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.08);
  }
  .banner-container {
    background: #EBF1FF;
    margin-bottom: 48px;
    .banner-info {
      float: left;
      width: 656px;
      text-align: left;
      margin: 66px 0 66px 84px;
      h3 {
        font-size: 24px;
        color: #333333;
        line-height: 36px
      }
      .info-contaner{
        margin-top: 20px;
      }
      em {
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        font-style: normal;
        display: block;
      }
      .learn-more {
        display: block;
        width: 184px;
        height: 40px;
        line-height: 40px;
        background-color: #0044CC;
        color: #ffffff;
        text-align: center;
        margin-top: 50px
      }
    }
    .banner-img {
      height: 320px;
      img {
        width: 340px;
        position: relative;
        top: 35px;
        right: 36px;
      }
    }
  }
  .desc {
    width: 1000px;
    margin: 0 auto;
    text-align: left;
    font-size: 14px;
    color: #666666;
    line-height: 28px;
    p {
      margin-bottom: 20px;
    }
  }
</style>
